import React from 'react'
import Input from '../Input';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ToolTipCustom from "../../Components/ToolTipCustom"
import styled from "styled-components";

const Container=styled.div`
display:grid;
grid-template-columns:25% max-content auto;
align-items:center;`;

const IconContainer=styled.div`
padding:5px;
cursor:pointer;`;

const Opcion = ({opcion}) => 
{
    const {Nombre,Precio}=opcion;
    const [PrecioStated, setPrecioStated] = React.useState(Precio)
    return (
        <Container >
            <p> {Nombre}</p>
            <Input  label="Precio"  value={PrecioStated} changeValue={setPrecioStated} type="number"/>
            <IconContainer><DeleteForeverIcon/></IconContainer>
        </Container>
    )
}

export default Opcion
